const $ = jQuery.noConflict()
export const select2Init = () => {
  $('.select-com').select2({
    minimumResultsForSearch: -1
  })
}
